import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsStrip } from './components/BenefitsStrip';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { TransformationSection } from './components/TransformationSection';
import { MethodSection } from './components/MethodSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { InsideCarousel } from './components/InsideCarousel';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TestimonialHighlight } from './components/TestimonialHighlight';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '2314996429237093';
export function App() {
  useMetaPixel();
  return <div className="min-h-full w-full bg-mp-black font-body" data-id="element-0" data-mp="4wxfu7a14id">
      <noscript data-id="element-1" data-mp="2zl3cxocsjc6w">
        <img height={1} width={1} style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="2zlld2w2kqak3" />
      </noscript>
      <main data-id="element-3" data-mp="38l053zye2t6p">
        <Hero data-id="element-4" data-mp="38k6wetfvdtlx" />
        <SocialProofBar data-id="element-5" data-mp="38nuqbtp88i16" />
        <BenefitsStrip data-id="element-6" data-mp="3dkl42adk71jf" />
        <TransformationSection data-id="element-7" data-mp="3dl4ktnrh3jvv" />
        <MethodSection data-id="element-8" data-mp="3dm5z013scmht" />
        <ForWhoSection data-id="element-9" data-mp="3dii694660445" />
        <TomosSection data-id="element-10" data-mp="nw2ak1lu1ioz" />
        <BonosSection data-id="element-11" data-mp="nuhj4kutefvc" />
        <InsideCarousel data-id="element-12" data-mp="nvar1p5ifbf2" />
        <TestimonialsSection data-id="element-13" data-mp="suncc5gqgafj" />
        <TestimonialHighlight data-id="element-14" data-mp="stuexv3nyxa2" />
        <PricingCards data-id="element-15" data-mp="st2iki28sviq" />
        <ComparisonTable data-id="element-16" data-mp="swgkxqawp4q6" />
        <GuaranteeSection data-id="element-17" data-mp="3688dot76uy6" />
        <FAQSection data-id="element-18" data-mp="35gmx6tbedlm" />
        <FinalCTA data-id="element-19" data-mp="34nabp7octvk" />
      </main>
      <Footer data-id="element-20" data-mp="3uct4vo20uv2l" />
      <StickyMobileCTA data-id="element-21" data-mp="3udawg7dqol46" />
      <PurchaseNotifications data-id="element-22" data-mp="3ubrhql7qei4i" />
    </div>;
}